import {devToolsEnhancer as createDevToolsEnhancer} from 'redux-devtools-extension';

import {isDevelopment} from '../../libs/shared/helpers/src/environment/envHelpers';

export const devToolsEnhancer = createDevToolsEnhancer({
  // Name the instance of Redux
  name: 'Front',
  // Stops actions catching until the 'Start recording' button is pressed
  shouldRecordChanges: false,
  // Disable Redux Devtools' hot reload, not sure what purpose it serves with HMR already enabled ¯\(ツ)/¯
  shouldHotReload: false,
  trace: isDevelopment(), // enable stacktrace of the origin of dispatched actions. Can slow down app so enabled only for development.
  features: {
    pause: true, // start/pause recording of dispatched actions
    lock: true, // lock/unlock dispatching actions and side effects
    persist: false, // persist states on page reloading
    export: true, // export history of actions in a file
    import: 'custom', // import history of actions from a file
    jump: true, // jump back and forth (time travelling)
    skip: true, // skip (cancel) actions
    reorder: true, // drag and drop actions in the history list
    dispatch: true, // dispatch custom actions or action creators
    test: false, // generate tests for the selected actions
  },
});
